import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AgentHome from './Index.vue';
import {
  hasAgentsPageData,
  prefetchAgentsPageData,
  revalidateAgentsPageData,
} from './agentsPageData';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'agent_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'agent_list',
          component: AgentHome,
          // Carrega antes de a tela aparecer. Sem isso a pagina monta vazia e so
          // entao dispara as chamadas, mostrando o "Buscando lista de usuarios".
          beforeEnter: (to, from, next) => {
            if (hasAgentsPageData()) {
              revalidateAgentsPageData();
              next();
              return;
            }
            // finally: uma falha de rede nao pode travar a navegacao.
            prefetchAgentsPageData().finally(() => next());
          },
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
            permissions: ['administrator', 'settings_manage'],
            pagePermission: 'page_settings_agents',
          },
        },
      ],
    },
  ],
};
